import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeFilterData } from "../../EnvConfig/env_config";
import { setSubLoading } from "../../Redux/Services/AuthSlice";
import { autoCompleteDelay } from "../../config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { ApiCall, FetchAutoCompleteData, FindTranslatedKey, convertToNumber, deleteData } from "../CommonComponents/CustomHooks";
import { handleDownloadExcel } from "../CommonComponents/ExportData";
import { AutoCompleteBox, FormButton, InputBox, Switch } from "../CommonComponents/InputBox";
import { Table } from "../CommonComponents/Table";

const BranchMaster = ({ menuText }) => {
    const dispatch = useDispatch();
    const inputrefs = useRef([]);
    const [loading, setLoading] = useState(false);
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [currentPageNo, setCurrentPageNo] = useState(1);
    let [result, setResult] = useState([]);
    const Hide = false;
    const [autoCompleteOptions, setAutoCompleteOptions] = useState([]);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [disableEdit, setDisableEdit] = useState(false)
    const [formData, setFormData] = useState({
        "branchID": '',
        "bCode": '',
        "bName": '',
        "contactPerson": '',
        "companyCode": '',
        "phoneNo": '',
        "eMailID": '',
        "address1": '',
        "address2": '',
        "cityCode": '',
        "stateCode": '',
        "countryCode": '',
        "zipCode": '',
        "remarks": '',
        "zoneCode": '',
        "branchType": '',
        "billPrefix": '',
        "branchBillAddress": '',
        "branchBillGSTPan": '',
        "branchBillBankDetail": '',
        "gstNo": '',
        "active": true
    })

    const handleClear = () => {
        setFormData({
            "branchID": '',
            "bCode": '',
            "bName": '',
            "contactPerson": '',
            "companyCode": '',
            "phoneNo": '',
            "eMailID": '',
            "address1": '',
            "address2": '',
            "cityCode": '',
            "stateCode": '',
            "countryCode": '',
            "zipCode": '',
            "remarks": '',
            "zoneCode": '',
            "branchType": '',
            "billPrefix": '',
            "branchBillAddress": '',
            "branchBillGSTPan": '',
            "branchBillBankDetail": '',
            "gstNo": '',
            "active": true
        });
        filterData.SearchText = ''
        getBranchMasterData()
      //  inputrefs.current['txtBranchCode'].focus();
        setDisableEdit(false)
    };

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall('/api/Master/InsertUpdateBranchMaster', formData)
        await dispatch(setSubLoading(false))
        if (data.status === 'ERROR' || data.status === 'EXPIRED' || data.status === 'UNAUTHORIZED' || data.status === 'SUCCESS') {
            await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
        }
    }

    const handleDelete = async (ID) => {
        await dispatch(setSubLoading(true))
        await deleteData('/api/Master/DeleteBranchMaster', { branchID: ID }, getBranchMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';

        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleEdit = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall('/api/Master/EditBranchMaster', { branchID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR'|| editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setDisableEdit(true)
            let record = editData.data
            setFormData((pre) => ({
                ...pre, ...record
            }))
        }

    }

    const getBranchMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        let GetData = {
            ...filterData,
            ...sortConfig,
            "PageIndex": PageIndex.toString(),
            "Type": "S",
        }
        setLoading(true)
        let data = await ApiCall('/api/Master/ShowBranchMaster', GetData)
        setResult(data)
        setLoading(false)
        if (data.Status === 'EXPIRED') {
            await NotificationSound(data.Status, data.Message, data.focus, inputrefs);
        }
    }

    const handleChange1 = (event, value) => {
        getBranchMasterData(value);
    };

    const autoCompleteTimeoutRef = useRef(null);
    const handleAutoCompleteChange = async (event, newValue, field, type) => {
        if (autoCompleteTimeoutRef.current) {
            clearTimeout(autoCompleteTimeoutRef.current);
        }
        if (event?.type === 'change') {
            autoCompleteTimeoutRef.current = setTimeout(async () => {
                const autoOptions = await FetchAutoCompleteData('', newValue, type, field);
                setAutoCompleteOptions(autoOptions ? autoOptions : []);
            }, autoCompleteDelay)
        }
    };

    useEffect(() => {
        getBranchMasterData();
    }, [sortConfig])

    useEffect(() => {
      //  inputrefs.current['txtBranchCode'].focus();
        document.title = 'Branch Master'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0"> {menuText ? menuText : FindTranslatedKey('Branch Master')}</h6>
                </div>

                <div className='card-body row'>
                 {/* {Hide ? <>*/}
                        <div className='row'>
                            <InputBox
                                label='Branch Code'
                                 PlaceHolderText='Branch Code'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtBranchCode'
                                value={formData.bCode}
                                disabled={disableEdit}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, bCode: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBranchName'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Branch Name'
                                 PlaceHolderText='Branch Name'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtBranchName'
                                value={formData.bName}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, bName: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtContactPerson'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Contact Person'
                                PlaceHolderText='Contact Person'
                                required={true}
                                inputrefs={inputrefs}
                                id='txtContactPerson'
                                value={formData.contactPerson}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, contactPerson: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCompanyCode'].focus();
                                    }
                                }}
                            />
                            <AutoCompleteBox
                                id="txtCompanyCode"
                                placeholder="Company Code"
                                label={"Company Code"}
                                required={true}
                                inputrefs={inputrefs}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        inputrefs.current["txtAddress1"].focus();
                                    }
                                }}
                                inputValue={formData.companyCode ? formData.companyCode : ""}
                                onInputChange={(event, newInputValue) => {
                                    handleAutoCompleteChange(
                                        event,
                                        newInputValue,
                                        "",
                                        "GetCompany",
                                    );
                                    setFormData({ ...formData, companyCode: newInputValue });
                                }}
                                maxLength="50"
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                            />
                            <InputBox
                                label='Address 1'
                                PlaceHolderText='Address 1'
                                inputrefs={inputrefs}
                                id='txtAddress1'
                                value={formData.address1}
                                required={true}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address1: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtAddress2'].focus();
                                    }
                                }}
                            /><InputBox
                                 label='Address 2'
                                  PlaceHolderText='Address 2'
                                inputrefs={inputrefs}
                                id='txtAddress2'
                                value={formData.address2}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, address2: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtCountryCode'].focus();
                                    }
                                }}
                            />

                            <AutoCompleteBox
                                label='Country'
                                placeholder='Country'
                                inputValue={formData.countryCode ? formData.countryCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetCountry');
                                        setFormData({ ...formData, countryCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtCountryCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtStateCode'].focus() };
                                }}
                            />

                            <AutoCompleteBox

                                label='State'
                                placeholder='State'
                                required={true}
                                inputValue={formData.stateCode ? formData.stateCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.countryCode, 'GetState_CountryWise');
                                        setFormData({ ...formData, stateCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                inputrefs={inputrefs}
                                id='txtStateCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtCityCode'].focus() };
                                }}
                            />

                            <AutoCompleteBox
                                label='City'
                                placeholder='City'
                                inputValue={formData.cityCode ? formData.cityCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.stateCode, 'GetCity_StateWise');
                                        setFormData({ ...formData, cityCode: newInputValue })
                                    }}
                                maxLength='50'
                                required={true}
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                inputrefs={inputrefs}
                                id='txtCityCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPinCode'].focus() };
                                }}
                            />
                            <AutoCompleteBox
                                label='Pin Code'
                                placeholder='Pin Code'
                                inputValue={formData.pinCode ? formData.pinCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, formData.cityCode, 'GetPinCode_CityWise');
                                        setFormData({ ...formData, pinCode: newInputValue })
                                    }}
                                maxLength='6'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtPinCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtPhoneNo'].focus() };
                                }}
                            />

                            <InputBox
                                label='Phone Number'
                                PlaceHolderText='Phone Number'
                                inputrefs={inputrefs}
                                id='txtPhoneNo'
                                value={formData.phoneNo}
                                required={true}
                                maxLength='10'
                                onChange={(e) => {
                                    setFormData({ ...formData, phoneNo: convertToNumber(e.target.value) })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtEmailID'].focus();
                                    }
                                }}
                            />

                            <InputBox
                                label='Email ID'
                                PlaceHolderText='Email ID'
                                inputrefs={inputrefs}
                                id='txtEmailID'
                                value={formData.eMailID}
                                required={true}
                                maxLength='150'
                                onChange={(e) => {
                                    setFormData({ ...formData, eMailID: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtRemarks'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Remarks'
                                PlaceHolderText='Remarks'
                                inputrefs={inputrefs}
                                id='txtRemarks'
                                value={formData.remarks}
                                maxLength='30'
                                onChange={(e) => {
                                    setFormData({ ...formData, remarks: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtZoneCode'].focus();
                                    }
                                }}
                            />

                            <AutoCompleteBox
                                label='Zone Code'
                                placeholder='Zone Code'
                                inputValue={formData.zoneCode ? formData.zoneCode : ''}
                                onInputChange={
                                    (event, newInputValue) => {
                                        handleAutoCompleteChange(event, newInputValue, '', 'GetZone');
                                        setFormData({ ...formData, zoneCode: newInputValue })
                                    }}
                                maxLength='50'
                                options={autoCompleteOptions}
                                setOptions={setAutoCompleteOptions}
                                required={true}
                                inputrefs={inputrefs}
                                id='txtZoneCode'
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['txtBranchType'].focus() };
                                }}
                            />
                            <InputBox
                                label='Branch Type'
                                PlaceHolderText='Branch Type'
                                inputrefs={inputrefs}
                                id='txtBranchType'
                                value={formData.branchType}
                                required={true}
                                maxLength='100'
                                onChange={(e) => {
                                    setFormData({ ...formData, branchType: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBillPrefix'].focus();
                                    }
                                }}
                            />

                            <InputBox
                                label='Bill Prefix'
                                PlaceHolderText='Bill Prefix'
                                inputrefs={inputrefs}
                                id='txtBillPrefix'
                                value={formData.billPrefix}
                                required={true}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, billPrefix: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBranchBillAddress'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Branch Bill Address'
                                PlaceHolderText='Branch Bill Address'
                                inputrefs={inputrefs}
                                id='txtBranchBillAddress'
                                value={formData.branchBillAddress}
                                required={true}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, branchBillAddress: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBranchBillGSTPan'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Branch Bill GST Pan'
                                PlaceHolderText='Branch Bill GST Pan'
                                inputrefs={inputrefs}
                                id='txtBranchBillGSTPan'
                                value={formData.branchBillGSTPan}
                                maxLength='20'
                                required={true}
                                onChange={(e) => {
                                    setFormData({ ...formData, branchBillGSTPan: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtBranchBillBankDetail'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='Branch Bill Bank Detail'
                                PlaceHolderText='Branch Bill Bank Detail'
                                inputrefs={inputrefs}
                                id='txtBranchBillBankDetail'
                                required={true}
                                value={formData.branchBillBankDetail}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, branchBillBankDetail: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtGSTNo'].focus();
                                    }
                                }}
                            />
                            <InputBox
                                label='GST Number'
                                PlaceHolderText='GST Number'
                                inputrefs={inputrefs}
                                id='txtGSTNo'
                                value={formData.gstNo}
                                required={true}
                                maxLength='20'
                                onChange={(e) => {
                                    setFormData({ ...formData, gstNo: e.target.value })
                                }}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        inputrefs.current['txtActive'].focus();
                                    }
                                }}
                            />

                            <Switch
                                label='Active'
                                inputrefs={inputrefs}
                                id='txtActive'
                                checked={formData.active}
                                onChange={(e) => setFormData({ ...formData, active: e.target.checked })}
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') { inputrefs.current['btnSave'].focus() };
                                }}
                            />
                        </div>
                   {/* </> : <></>}*/}
                   
                    <div className='row pb-1'>
                        <FormButton
                            id='btnSave'
                            inputrefs={inputrefs}
                            //save={false}
                            handleSubmit={handleSubmit}
                            handleExport={async () => {
                                await dispatch(setSubLoading(true))
                                await handleDownloadExcel('/api/Master/ShowBranchMaster', filterData, 'Branch Master')
                                await dispatch(setSubLoading(false))
                            }}
                            handleClear={handleClear} />
                    </div>
                    <Table handleEdit={handleEdit}
                        handleDelete={handleDelete}
                        PageName={'BranchMaster'}
                        loading={loading}
                        handleFilter={() => {
                            getBranchMasterData()
                            setFilterData({
                                ...filterData,
                            })
                        }}
                        filterData={filterData}
                        tableData={result}
                        setFilterData={setFilterData}
                        currentPageNo={currentPageNo}
                        handleChange1={handleChange1}
                        handleSorting={handleSorting}
                        sortConfig={sortConfig}
                    />
                </div>
                
            </div>

          
        </>
    )
}

export default BranchMaster;